<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title-white">{{ $t("discovery.header_title") }}</h1>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.time") }}<br />2018-{{ currentYear }}
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">{{ $t("common.role") }}<br />Design Lead</h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.platform") }}<br />Mobile, Desktop
            </h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.time") }}<br />2018-2021</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.role") }}<br />Design Lead</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.platform") }}<br />Mobile, Desktop
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("discovery.project.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("discovery.project.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("discovery.project.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img class="fill-in-img" :src="project" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("discovery.challenges.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("discovery.challenges.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img class="fill-in-img" :src="challenges" />
                <div class="text-on-image-centered">
                  {{ $t("discovery.challenges.text_in_image") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section">
        <div class="section section-black">
          <div class="container vision-margin">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <div>
                  <h3 class="description">
                    {{ $t("discovery.vision.title") }}
                  </h3>
                  <h1 class="title-white text-left">
                    {{ $t("discovery.vision.description")
                    }}<span v-if="!isCN" class="hightlight-text">{{
                      $t("discovery.vision.hightlight_text")
                    }}</span>
                  </h1>
                </div>
              </div>
              <div class="md-layout-item md-size-10 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="visions[0].image" />
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="visions[1].image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-55 md-small-size-100">
                <div class="top-padding">
                  <h3 class="description">
                    <span class="hightlight-text-inverse">{{
                      $t("discovery.intent.title1")
                    }}</span>
                  </h3>
                  <h2 class="title text-left">
                    {{ $t("discovery.intent.description1") }}
                  </h2>
                </div>
              </div>
              <div class="md-layout-item md-size-109 md-small-size-25"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[0].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div class="top-padding">
                  <h3 class="description">
                    <span class="hightlight-text-inverse">{{
                      $t("discovery.intent.title2")
                    }}</span>
                  </h3>
                  <h2 class="title text-left">
                    {{ $t("discovery.intent.description2") }}
                  </h2>
                </div>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[1].image" />
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[2].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div class="top-padding">
                  <h3 class="description">
                    <span class="hightlight-text-inverse">{{
                      $t("discovery.intent.title3")
                    }}</span>
                  </h3>
                  <h2 class="title text-left">
                    {{ $t("discovery.intent.description3") }}
                  </h2>
                </div>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[8].image" />
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[9].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container excution-spcial-margin">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <h3 class="description">
                  <span class="hightlight-text-inverse">{{
                    $t("discovery.intent.title4")
                  }}</span>
                </h3>
              </div>
              <div class="md-layout-item md-size-100 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("discovery.intent.description4") }}
                </h2>
              </div>
            </div>
            <div class="md-layout margin-top-32">
              <div class="md-layout-item md-size-20 md-small-size-50">
                <img :src="intents[3].image" />
              </div>
              <div class="md-layout-item md-size-20 md-small-size-50">
                <img :src="intents[4].image" />
              </div>
              <div
                class="md-layout-item md-size-20 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[5].image" />
              </div>
              <div
                class="md-layout-item md-size-20 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[6].image" />
              </div>
              <div
                class="md-layout-item md-size-20 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="intents[7].image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section large-section-black">
        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div>
                  <h2 class="title-white">
                    {{ $t("discovery.result.title") }}
                  </h2>
                  <h4 class="description text-left">
                    {{ $t("discovery.result.description") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div>
                  <h3 class="description">
                    {{ $t("discovery.discovery.title") }}
                  </h3>
                  <h2 class="title-white">
                    {{ $t("discovery.discovery.description") }}
                  </h2>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.discovery.data1") }}
                  </h4>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.discovery.data2") }}
                  </h4>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.discovery.data3") }}
                  </h4>
                </div>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[0].image" />
                <h4 class="description text-center">2019</h4>
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[1].image" />
                <h4 class="description text-center">2020</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div>
                  <h3 class="description">
                    {{ $t("discovery.search.title") }}
                  </h3>
                  <h2 class="title-white">
                    {{ $t("discovery.search.description") }}
                  </h2>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.search.data1") }}
                  </h4>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.search.data2") }}
                  </h4>
                </div>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[2].image" />
                <h4 class="description text-center">2019</h4>
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[3].image" />
                <h4 class="description text-center">2020</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="section section-black">
          <div class="container margin-bottom-64">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div>
                  <h3 class="description">
                    {{ $t("discovery.details.title") }}
                  </h3>
                  <h2 class="title-white">
                    {{ $t("discovery.details.description") }}
                  </h2>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.details.data1") }}
                  </h4>
                  <h4 class="description data-content text-left">
                    {{ $t("discovery.details.data2") }}
                  </h4>
                </div>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-100"></div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[4].image" />
                <h4 class="description text-center">2019</h4>
              </div>
              <div
                class="md-layout-item md-size-25 md-small-size-50"
                :class="{ 'mobile-img-top-margin': isMobileDevice }"
              >
                <img :src="results[5].image" />
                <h4 class="description text-center">2020</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "discovery-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/discovery/background.png")
    },
    project: {
      type: String,
      default: require("@/assets/img/discovery/project.png")
    },
    challenges: {
      type: String,
      default: require("@/assets/img/discovery/challenges.png")
    }
  },
  data() {
    return {
      isCN: true,
      isMobileDevice: this.$isMobile,
      currentYear: new Date().getFullYear(),
      visions: [
        { image: require("@/assets/img/discovery/vision_1.png") },
        { image: require("@/assets/img/discovery/vision_2.png") }
      ],
      intents: [
        { image: require("@/assets/img/discovery/intent_1.png") },
        { image: require("@/assets/img/discovery/intent_2.png") },
        { image: require("@/assets/img/discovery/intent_3.png") },
        { image: require("@/assets/img/discovery/intent_4.png") },
        { image: require("@/assets/img/discovery/intent_5.png") },
        { image: require("@/assets/img/discovery/intent_6.png") },
        { image: require("@/assets/img/discovery/intent_7.png") },
        { image: require("@/assets/img/discovery/intent_8.png") },
        { image: require("@/assets/img/discovery/intent_9.png") },
        { image: require("@/assets/img/discovery/intent_10.png") }
      ],
      results: [
        { image: require("@/assets/img/discovery/result_1.png") },
        { image: require("@/assets/img/discovery/result_2.png") },
        { image: require("@/assets/img/discovery/result_3.png") },
        { image: require("@/assets/img/discovery/result_4.png") },
        { image: require("@/assets/img/discovery/result_5.png") },
        { image: require("@/assets/img/discovery/result_6.png") }
      ]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 53.12%, rgba(0, 0, 0, 0.53) 63.78%, #000000 100%),  url(${this.header})`,
        backgroundSize: `cover`
      };
    }
  },
  watch: {
    $route(to, from) {
      if (to.params["lang"] === "cn") {
        this.isCN = true;
      } else {
        this.isCN = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-padding {
  padding-top: 4rem;
}
.vision-margin {
  margin-top: 9rem;
  margin-bottom: 9rem;
}
</style>
